export class ApiConfig {

    headers: any = {
        'x-api-key': 'xwghywubaN2xeBaRPEARH9B7rn8hU5w03S7ZKCBF',
        'Content-Type': 'application/json'
    };
    alertsURL: string = 'https://jbo875x4ri.execute-api.us-east-1.amazonaws.com/prod/alerts';
    eventsURL: string = 'https://jbo875x4ri.execute-api.us-east-1.amazonaws.com/prod/events';
    threatsURL: string = 'https://jbo875x4ri.execute-api.us-east-1.amazonaws.com/prod/chartdata';
    threatLevelURL: string = 'https://jbo875x4ri.execute-api.us-east-1.amazonaws.com/prod/threatlevel';
    rawLogsURL: string = 'https://jbo875x4ri.execute-api.us-east-1.amazonaws.com/prod/rawlogs';
    devicesURL: string = 'https://jbo875x4ri.execute-api.us-east-1.amazonaws.com/prod/devices';
    remoteHostsURL: string = 'https://jbo875x4ri.execute-api.us-east-1.amazonaws.com/prod/remotehosts';

    isoBaseURL: string = 'https://5qz7bj8qo1.execute-api.us-east-1.amazonaws.com/development/';
    isoHeaders: any = {
        'x-api-key': 'xwghywubaN2xeBaRPEARH9B7rn8hU5w03S7ZKCBF', //XXX: NOT USED NOW
        'Content-Type': 'application/json'
    };
    isoCreateURL: string = this.isoBaseURL + 'iso';
    isoLocationURL: string = this.isoBaseURL + 'iso/';
    
    constructor() {
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/api-config/api-config.ts